const $segmentationQuestions = $('.js-segmentation-questions');

if ($segmentationQuestions.length > 0) {
  const stepCount = parseInt($segmentationQuestions.attr('data-steps-count'), 10);
  const $answers = $('.js-segmentation-anwsers');

  $answers.on('click', function (event) {
    event.preventDefault();
    const value = $(this).attr('data-value');
    const input = $(this).attr('data-input');
    const target = $(this).attr('data-target');
    const $questionBox = $(this).parents('.js-question-box');

    // reseting
    $('.js-question-box:not([data-first-question])')
      .not($questionBox)
      .addClass('hidden')
      .find('.active')
      .removeClass('active');

    $questionBox.find('.active').removeClass('active');

    // apply anwser
    $(this).addClass('active');

    if (input && value) {
      $('input[name=' + input + ']').val(value);
    }

    // jump to next question
    if (target) {
      $('#' + target).removeClass('hidden');
    }

    // display/hide submit button
    $segmentationQuestions.find('.js-answers-submit').toggleClass(
      'hidden',
      $segmentationQuestions.find('.active').length < stepCount
    );
  });
}
